<div class="grid" [formGroup]="form">
  <mat-form-field>
    <mat-label>
      <ng-content select="app-separator-label"></ng-content>
    </mat-label>

    <input formControlName="value" matInput>

    <button (click)="toggleSeparator(); $event.stopPropagation()"
      [attr.aria-label]="labelSuffix"
      [matTooltip]="labelSuffix"
      class="suffix"
      mat-icon-button
      matSuffix>
      {{ separatorLabel }}
    </button>

    @if (byEntry) {
      <button
        (click)="toggleEntry(); $event.stopPropagation()"
        [attr.aria-label]="containsTooltip"
        class="suffix"
        [matTooltip]="containsTooltip"
        mat-icon-button
        matSuffix>
        <mat-icon>{{ containsIcon }}</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
